<div class="empty-state-container">
  <div class="empty-state-content empty-state" *ngFor="let op of optionsEmptyState">
    <div class="{{ optionsEmptyState.length > 1 ? 'small-top-image' : 'top-image' }}">
      <u-icon [model]="{ type: 'img', value: op.iconSvg }" [inSvg]="op.iconSvg.darkUrl ? '' : op.iconSvg.lightUrl"></u-icon>
    </div>
    <div class="{{ optionsEmptyState.length > 1 ? 'small-title' : 'title' }}">
      {{ op.titleLine }}
    </div>
    <div class="{{ optionsEmptyState.length > 1 ? 'small-sub-title' : 'sub-title' }}">
      {{ op.subtitleLine }}
      <ng-content *ngIf="op.subtitleLine2">
        <br />
        {{ op.subtitleLine2 }}
      </ng-content>
      <ng-content *ngIf="op.subtitleLine3">
        <br />
        {{ op.subtitleLine3 }}
      </ng-content>
      <u-button
        *ngIf="op.learnMoreLink"
        [styleType]="'link'"
        [typeElement]="'primary'"
        [sizeElement]="optionsEmptyState.length > 1 ? 'extra-small' : 'small'"
        [versionNumber]="2"
        [label]="'Learn More'"
        (onClick)="openLearnMore(op.learnMoreLink)"
      ></u-button>
    </div>

    <div class="btn-wrapper">
      <u-button
        *ngIf="createNewOption"
        [label]="op.btnText"
        [typeElement]="'primary'"
        (onClick)="createNew(op.type)"
        [versionNumber]="2"
        data-cy="create-card"
      ></u-button>
    </div>
  </div>
</div>
